import { render, staticRenderFns } from "./SolicitudInformacionModificar.vue?vue&type=template&id=ca586d9e&scoped=true&lang=pug&"
import script from "./SolicitudInformacionModificar.vue?vue&type=script&lang=js&"
export * from "./SolicitudInformacionModificar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca586d9e",
  null
  
)

export default component.exports